import { render, staticRenderFns } from "./base-table.vue?vue&type=template&id=7a083613"
import script from "./base-table.vue?vue&type=script&lang=js"
export * from "./base-table.vue?vue&type=script&lang=js"
import style0 from "./base-table.vue?vue&type=style&index=0&id=7a083613&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports